import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import * as globals from "../globals";
import * as restMethods from "../api/restMethods";

const getSubscriptions = async (auth) => {
    const url = `${globals.apiRoot}/subscriptions`;
    var response = await restMethods.getJson(auth, url);
    return await response.json();
}


export const useSubscriptions = (options) => {

    // TODO: move this into REDUX to eliminate fetches each time?
    // But if so, the websocket would need to notify clients when new subscriptions are added
    // But the websocket can't do that because websockets are subscription-specific right now i think

    const auth = useAuth();
    const [subscriptions, setSubscriptions] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [refreshCounter, setRefreshCounter] = useState(0);

    useEffect(() => {

        const f = async () => {
            setLoading(true);
            try {
                const subs = await getSubscriptions(auth);
                setSubscriptions(subs);
            }
            catch (err) {
                console.error(err);
                setError(err.message);
                setSubscriptions([]);
            }
            setLoading(false);
        }
        f();

    }, [refreshCounter]);

    const refresh = () => setRefreshCounter(refreshCounter+1);

    return [subscriptions, loading, error, refresh]

}

